<template>
    <div class="panel panel-default">
        <div class="inspection-tab-white" id="equipment-inspection-tab">
            <div class="row">
                <div class="col-lg-12">
                    <div class="test-drive-title">Комментарий к автомобилю</div>
                    <div class="test-drive-comment" v-if="inspection_equipment">{{ inspection_equipment.comment }}</div>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-4">
                    <div class="equipment-bordered">
                        <table class="table table-striped striped-table-inspection">
                            <thead>
                            <tr>
                                <th></th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody v-if="inspection_equipment">
                            <tr>
                                <td>Тип салона</td>
                                <td>{{ (inspection_equipment.interior_type != null) ? inspection_equipment.interior_type.name : '' }}</td>
                            </tr>
                            <tr>
                                <td>Цвет салона</td>
                                <td>{{ (inspection_equipment.color != null) ? inspection_equipment.color.name : '' }}</td>
                            </tr>
                            <tr>
                                <td>Двухцветный салон</td>
                                <td>{{(inspection_equipment.two_color_interior) ? 'Да' : 'Нет'}}</td>
                            </tr>
                            <tr>
                                <td>Дополнительный цвет салона</td>
                                <td>{{ (inspection_equipment.additional_color != null) ? inspection_equipment.additional_color.name : '' }}</td>
                            </tr>
                            <tr>
                                <td>Передние подушки</td>
                                <td>{{ (inspection_equipment.airbag_number != null) ? inspection_equipment.airbag_number.number : '' }}</td>
                            </tr>
                            <tr>
                                <td>Боковые подушки</td>
                                <td>{{ (inspection_equipment.side_airbag_number != null) ? inspection_equipment.side_airbag_number.number : '' }}</td>
                            </tr>
                            <tr>
                                <td>ABS</td>
                                <td>{{(inspection_equipment.abs) ? 'Да' : 'Нет'}}</td>
                            </tr>
                            <tr>
                                <td>Bluetooth</td>
                                <td>{{(inspection_equipment.bluetooth) ? 'Да' : 'Нет'}}</td>
                            </tr>
                            <tr>
                                <td>Антипробуксовочная система</td>
                                <td>{{(inspection_equipment.anti_slip_system) ? 'Да' : 'Нет'}}</td>
                            </tr>
                            <tr>
                                <td>Система курсовой устойчивости</td>
                                <td>{{(inspection_equipment.stability_control) ? 'Да' : 'Нет'}}</td>
                            </tr>
                            <tr>
                                <td>Мультимедийная система</td>
                                <td>{{ (inspection_equipment.multimedia_control_system) ? 'Да' : 'Нет' }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="col-lg-4">
                    <div class="equipment-bordered">
                        <table class="table table-striped striped-table-inspection">
                            <thead>
                            <tr>
                                <th></th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody v-if="inspection_equipment">
                            <tr>
                                <td>Электропривод сидений</td>
                                <td>{{ (inspection_equipment.electric_seats_type != null) ? inspection_equipment.electric_seats_type.name : '' }}</td>
                            </tr>
                            <tr>
                                <td>Память сидений</td>
                                <td>{{ (inspection_equipment.memory_seats_type != null) ? inspection_equipment.memory_seats_type.name : '' }}</td>
                            </tr>
                            <tr>
                                <td>Вентиляция сидений</td>
                                <td>{{ (inspection_equipment.vent_seats_type != null) ? inspection_equipment.vent_seats_type.name : '' }}</td>
                            </tr>
                            <tr>
                                <td>Подогрев сидений</td>
                                <td>{{ (inspection_equipment.seats_heat_type != null) ? inspection_equipment.seats_heat_type.name : '' }}</td>
                            </tr>
                            <tr>
                                <td>Электростеклоподъемники</td>
                                <td v-if="inspection_equipment.power_windows == null"></td>
                                <td v-else-if="inspection_equipment.power_windows == '3'">нет</td>
                                <td v-else-if="inspection_equipment.power_windows == '2'">передние и задние</td>
                                <td v-else>передние</td>
                            </tr>
                            <tr>
                                <td>Обогрев зеркал</td>
                                <td>{{(inspection_equipment.heated_mirrors) ? 'Да' : 'Нет'}}</td>
                            </tr>
                            <tr>
                                <td>Электропривод зеркал</td>
                                <td>{{(inspection_equipment.power_mirrors) ? 'Да' : 'Нет'}}</td>
                            </tr>
                            <tr>
                                <td>Электоскладывающиеся</td>
                                <td>{{(inspection_equipment.electric_folding_mirrors) ? 'Да' : 'Нет'}}</td>
                            </tr>
                            <tr>
                                <td>Пневмоподвеска</td>
                                <td>{{(inspection_equipment.air_suspension) ? 'Да' : 'Нет'}}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="col-lg-4">
                    <div class="equipment-bordered">
                        <table class="table table-striped striped-table-inspection">
                            <thead>
                            <tr>
                                <th></th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody v-if="inspection_equipment">
                            <tr>
                                <td>Мультимедия</td>
                                <td>{{(inspection_equipment.multimedia) ? 'Да' : 'Нет'}}</td>
                            </tr>
                            <tr>
                                <td>CD</td>
                                <td v-if="inspection_equipment.multimedia">
                                    {{(inspection_equipment.cd) ? 'Да' : 'Нет'}}
                                </td>
                                <td v-else>X</td>
                            </tr>
                            <tr>
                                <td>MP3</td>
                                <td v-if="inspection_equipment.multimedia">
                                    {{(inspection_equipment.mp3) ? 'Да' : 'Нет'}}
                                </td>
                                <td v-else>X</td>
                            </tr>
                            <tr>
                                <td>DVD</td>
                                <td v-if="inspection_equipment.multimedia">
                                    {{(inspection_equipment.dvd) ? 'Да' : 'Нет'}}
                                </td>
                                <td v-else>X</td>
                            </tr>
                            <tr>
                                <td>WMA</td>
                                <td v-if="inspection_equipment.multimedia">
                                    {{(inspection_equipment.wma) ? 'Да' : 'Нет'}}
                                </td>
                                <td v-else>X</td>
                            </tr>
                            <tr>
                                <td>USB</td>
                                <td v-if="inspection_equipment.multimedia">
                                    {{(inspection_equipment.usb) ? 'Да' : 'Нет'}}
                                </td>
                                <td v-else>X</td>
                            </tr>
                            <tr>
                                <td>TV</td>
                                <td v-if="inspection_equipment.multimedia">
                                    {{(inspection_equipment.tv) ? 'Да' : 'Нет'}}
                                </td>
                                <td v-else>X</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-4">
                    <div class="equipment-bordered">
                        <table class="table table-striped striped-table-inspection">
                            <thead>
                            <tr>
                                <th></th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody v-if="inspection_equipment">
                            <tr>
                                <td>Мониторы</td>
                                <td>
                                    {{ (inspection_equipment.monitors) ? 'Да' : 'Нет' }}
                                </td>
                            </tr>
                            <tr>
                                <td>Потолочный</td>
                                <td v-if="inspection_equipment.monitors">
                                    {{ (inspection_equipment.ceiling_monitor) ? 'Да' : 'Нет' }}
                                </td>
                                <td v-else>X</td>
                            </tr>
                            <tr>
                                <td>На консоли между сиденьями</td>
                                <td v-if="inspection_equipment.monitors">
                                    {{ (inspection_equipment.console_between_seats) ? 'Да' : 'Нет' }}
                                </td>
                                <td v-else>X</td>
                            </tr>
                            <tr>
                                <td>В подголовниках</td>
                                <td v-if="inspection_equipment.monitors">
                                    {{ (inspection_equipment.head_restraints) ? 'Да' : 'Нет' }}
                                </td>
                                <td v-else>X</td>
                            </tr>
                            <tr>
                                <td>На передней панели</td>
                                <td v-if="inspection_equipment.monitors">
                                    {{ (inspection_equipment.front_panel) ? 'Да' : 'Нет' }}
                                </td>
                                <td v-else>X</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="col-lg-4">
                    <div class="equipment-bordered">
                        <table class="table table-striped striped-table-inspection">
                            <thead>
                            <tr>
                                <th></th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody v-if="inspection_equipment">
                            <tr>
                                <td>Навигация</td>
                                <td>{{ (inspection_equipment.navigation) ? 'Да' : 'Нет' }}</td>
                            </tr>
                            <tr>
                                <td>Мультируль</td>
                                <td>{{ (inspection_equipment.multi_steering) ? 'Да' : 'Нет' }}</td>
                            </tr>
                            <tr>
                                <td>Датчик дождя</td>
                                <td>{{ (inspection_equipment.rain_sensor) ? 'Да' : 'Нет' }}</td>
                            </tr>
                            <tr>
                                <td>Датчик света</td>
                                <td>{{ (inspection_equipment.light_sensor) ? 'Да' : 'Нет' }}</td>
                            </tr>
                            <tr>
                                <td>Регулируемая рулевая</td>
                                <td>{{ (inspection_equipment.steering_column_type != null) ? inspection_equipment.steering_column_type.name : '' }}</td>
                            </tr>
                            <tr>
                                <td>Круиз контроль</td>
                                <td>{{ (inspection_equipment.cruise_control) ? 'Да' : 'Нет' }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="col-lg-4">
                    <div class="equipment-bordered">
                        <table class="table table-striped striped-table-inspection">
                            <thead>
                            <tr>
                                <th></th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody v-if="inspection_equipment">
                            <tr>
                                <td>Тип климатической</td>
                                <td>{{ (inspection_equipment.ac_type != null) ? inspection_equipment.ac_type.name : '' }}</td>
                            </tr>
                            <tr v-if="inspection_equipment.ac_zone_id != null">
                                <td>Количество зон климата</td>
                                <td>{{ inspection_equipment.ac_zone.number }}</td>
                            </tr>
                            <tr>
                                <td>Обогрев лобового стекла</td>
                                <td>{{ (inspection_equipment.glass_heat_type != null) ? inspection_equipment.glass_heat_type.name : '' }}</td>
                            </tr>
                            <tr>
                                <td>Люк</td>
                                <td>{{ (inspection_equipment.luke) ? 'Да' : 'Нет' }}</td>
                            </tr>
                            <tr>
                                <td>Панорамная крыша</td>
                                <td>{{ (inspection_equipment.panoramic_roof) ? 'Да' : 'Нет' }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios'
    import _ from 'lodash'

    export default {
        name: 'InspectionEquipment',
        props: ['inspection_id'],
        asyncComputed: {
            inspection_equipment() {
                return axios
                    .get('/api/inspections/' + this.inspection_id + '/equipment', {
                        params: {}
                    })
                    .then(({data}) => {
                        return data
                    })
            },
        },
        methods: {}
    }
</script>

<style lang="less">
    @import "../../less/_boot";

    .inspection-tab-white {
        background-color: #fff;
        padding: 10px;
    }

    .cos-form-5 {
        box-sizing: border-box;
        width: 19.5%;
        display: block;
        float: left;
        margin-left: 0.5%;
    }

    .cos-form-5:first-child {
        margin-left: 0;
    }

    .cos-form-5 select {
        color: #999999;
    }

    .select-data .date_from {
        border-right: none;
        width: 50%;
        display: inline-block;
    }

</style>



// WEBPACK FOOTER //
// InspectionEquipment.vue?3a2ba2d2